
import {
	EventParticipation,
	EventParticipationState,
	EventState,
	EventType,
} from "@/models";
import { defineComponent, PropType } from "@vue/runtime-core";
import Card from "@/components/ui/Card.vue";
import Timestamp from "@/components/ui/Timestamp.vue";
import Btn from "@/components/ui/Btn.vue";
import ParticipationThumbnail from "@/components/student/ParticipationThumbnail.vue";

export default defineComponent({
	name: "PublicEventParticipationPreview",
	components: { Card, Timestamp, Btn, ParticipationThumbnail },
	props: {
		participation: {
			type: Object as PropType<EventParticipation>,
			required: true as const,
		},
		courseId: {
			type: String,
			required: true as const,
		},
		slug: {
			type: String,
			required: true as const,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["bookmark"],
	computed: {
		isParticipable(): boolean {
			return (
				this.participation.event.state === EventState.OPEN &&
				this.participation.state === EventParticipationState.IN_PROGRESS
			);
		},
		showThumbnail(): boolean {
			return this.participation.event.event_type === EventType.SELF_SERVICE_PRACTICE;
		},
	},
});
